import React, { useState } from 'react';
import { cn } from '../Button';
import { getInitials } from '../../../utils/helpers/avatar';

interface AvatarProps {
  src: string;
  alt: string;
  name: string;
  className?: string;
  imageClassName?: string;
  fallbackClassName?: string;
}

const Avatar: React.FC<AvatarProps> = ({ src, alt, name, className, imageClassName, fallbackClassName }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <div className={cn('relative h-10 w-10 overflow-hidden rounded-2xl bg-slate-100', className)}>
      {!hasError ? (
        <img
          src={src}
          alt={alt}
          className={cn('h-full w-full object-cover', imageClassName)}
          loading="lazy"
          onError={() => setHasError(true)}
        />
      ) : (
        <div
          className={cn(
            'flex h-full w-full items-center justify-center bg-gradient-to-br from-sky-100 to-emerald-100 text-xs font-bold text-sky-700',
            fallbackClassName
          )}
        >
          {getInitials(name)}
        </div>
      )}
    </div>
  );
};

export default Avatar;
